<div class="wrapper" [class.standalone]="standalone">
  <div class="title text-center" translate="home-estimator.title"></div>
  <div class="sub-title text-center" translate="home-estimator.sub-title"></div>
  <form (ngSubmit)="onSubmit.emit()" class="has-pos-rel" [formGroup]="homeEstimatorForm">
    <div class="input-wrapper">
      <app-input class="street-number" label="{{'home-estimator.street-number' | translate}}" [formControl]="homeEstimatorForm.controls['streetNumber']" [parentFormGroup]="homeEstimatorForm"></app-input>
      <app-input class="street-name" label="{{'home-estimator.street-name' | translate}}" [formControl]="homeEstimatorForm.controls['streetName']" [parentFormGroup]="homeEstimatorForm"></app-input>
      <app-input class="street-direction" label="{{'home-estimator.street-direction' | translate}}" [formControl]="homeEstimatorForm.controls['streetDirection']" [parentFormGroup]="homeEstimatorForm"></app-input>
      <app-input class="unit-number" label="{{'home-estimator.unit-number' | translate}}" [formControl]="homeEstimatorForm.controls['unitNumber']" [parentFormGroup]="homeEstimatorForm"></app-input>
      <app-input class="city" label="{{'home-estimator.city' | translate}}" [formControl]="homeEstimatorForm.controls['city']" [parentFormGroup]="homeEstimatorForm"></app-input>
      <div class="province">
        <div translate="home-estimator.province"></div>
        <div class="province-name" translate="provinces.bc"></div>
      </div>
    </div>

    <app-home-estimator-suggestions *ngIf="suggestions"
                                    [suggestions]="suggestions"
                                    (onSuggestionClick)="onSuggestionClick.emit($event)"
                                    (onClose)="onSuggestionsClose.emit()">
    </app-home-estimator-suggestions>

    <div *ngIf="hasError" class="error-container text-center">
      <div class="error-title" translate="home-estimator.error-title"></div>
      <div class="error-message" translate="home-estimator.error-message"></div>
    </div>
    <div class="is-flex has-flex-content-center button-wrapper">
      <button type="submit" class="btn btn-secondary" [disabled]="!homeEstimatorForm.valid">
        <span class="full-width" translate="home-estimator.get-my-estimate"></span>
      </button>
    </div>
    <ng-container *ngIf="standalone">
      <hr/>
      <div class="contact-agent text-center">
        {{'home-estimator.footer1' | translate}} <a routerLink="/find-agent-or-office/agent" translate="home-estimator.footer2"></a> {{'home-estimator.footer3' | translate}}
      </div>
    </ng-container>
  </form>
</div>
